import React from "react";
import PortalLayout from "../components/layouts/Portal";
import { AuthGurad } from "../../routes/AuthGurad";
import Dashboard from "../pages/Dashboard";
import RolesManagement from "../pages/Acl/RolesManagement";
import RolesModules from "../pages/Acl/RolesManagement/Modules";
import ModulesPermissions from "../pages/Acl/RolesManagement/Permissions";
import QRGeneration from "../pages/QRGeneration";
import QRGenerationDetails from "../pages/QRGeneration/QRGenerationDetails";
import FeasibilityAssessmentSubject from "../pages/FeasibilityAssessment/Subject";
// import { AppointmentDetails } from "../../pages/appointment-details/AppointmentDetails";
import OnBoardUser from "../pages/Acl/OnboardUser";
import SlotManagement from "../pages/SlotsManagement";
import ApheresisRequests from "../pages/FeasibilityAssessment/ApheresisRequests";
import BMRSlots from "../pages/FeasibilityAssessment/BMRSlots";
import QRCodeGeneration from "../pages/QRCodeGeneration";
import InBound from "../pages/LogisticsManagement/InBound";
import OutBound from "../pages/LogisticsManagement/OutBound";
import ApprovalReceived from "../pages/LSMAcceptance/ApprovalReceived";
import LSMReceived from "../pages/LSMAcceptance/LSMReceived";
import GenerateQr from "../pages/QRCodeGeneration/GenerateQr";
import Location from "../pages/Master/Location";
import Help from "../pages/Master/help";
import CreateHelp from "../pages/Master/help/createHelp";
import DetailHelp from "../pages/Master/help/detailHelp";
import ViewProcessingAccordian from "../pages/Master/help/viewProcessingAccordian";
import TemplateManagement from "../pages/TemplateManagement";
// import FbLayout from '../../lib/form-builder/layout/fbLayout';
import FbRoutes from "../../lib/form-builder/routes/FbRoutes";
// import FbLayout from '../../lib/form-builder/layout/FbLayout';
import InBoundView from "../pages/LogisticsManagement/InBound/InBoundView";
import InboundFormContainer from "../pages/InboundFormContainer";
import ApprovedSubjectDetails from "../pages/LSMAcceptance/ApprovalReceived/ApprovedSubjectDetails";
import NotificationContainer from "../components/features/NotificationContainer";
import PendingTask from "../../bmr/pages/pendingTask/pendingTask";
import { BmrAppointmentDetails } from "../pages/appointment-details/BmrAppointmentDetails";
// import FbContext from "../../lib/form-builder/context/FbContext";
import FormBuilder from "../../lib/form-builder/main";
import LSMRejectionReason from "../pages/Master/LSMRejectionReason";
import Manufacturer from "../pages/Manufacturer/index.js";
import ManufacturerView from "../pages/Manufacturer/ManufacturerView.js";
import QualityControl from "../pages/QualityControl/index.js";
// import QualityControlView from "../pages/QualityControl/QualityControlView.js";
import QualityApproval from "../pages/QualityApproval/index.js";
// import QualityApprovalView from "../pages/QualityApproval/QualityApprovalView.js";
import LSMApprovalRequests from "../pages/FeasibilityAssessment/ApprovalRequests/index.js";
import QualityControlView1 from "../pages/QualityControl/qualtityControlView.js";
import LSMAcceptanceReason from "../pages/Master/LSMAcceptanceReason/index.js";
import LeukapheresisCondition from "../pages/Master/LeukapheresisCondition/index.js";
import StorageLocation from "../pages/Master/StorageLocation/index.js";
import RemanufacturingReasons from "../pages/Master/RemanufacturingReasons/index.js";
import DeliveryPartners from "../pages/Master/DeliveryPartners/index.js";
import PrintDetails from "../pages/Master/PrintDetails/index.js";
import ProductCalculations from "../pages/Master/ProductCalculations/index.js";
import PaymentStatus from "../pages/FeasibilityAssessment/PaymentStatus/index.js";
import TableManagement from "../pages/Master/TableManagement/index.js";
import FormAssigned from "../../lib/form-assigned/index.js";
import AssignSectionPermission from "../../lib/form-assigned/assign-section-permission/index.js";
import DownloadCenter from "../pages/Master/DownloadCenter/index.js";
import ViewDetails from "../pages/Master/DownloadCenter/ViewDetail/index.js";
import EmailTemplate from "../pages/Master/EmailTemplate/index.js";
import CreateEmailTemplate from "../pages/Master/EmailTemplate/CreateEmailTemplate/index.js";
import Message from '../../pages/message/Message';
import Disclaimer from "../pages/Master/Disclaimer/index.js";
import AddNewDisclaimer from "../pages/Master/Disclaimer/Add New Disclaimer/index.js";
import CityManagement from "../pages/Master/City/index.js";
import LogsManagement from "../pages/Master/Logs/index.js";
import ViewLog from "../pages/Master/Logs/ViewLog.js";
import StateManagement from "../pages/Master/State/index.js";
import CountryManagement from "../pages/Master/Country/index.js";
import FormBuilderMasterData from "../pages/Master/formbuilder/formbuildermaster.js";

const BmrRoutes = {
  path: "/bmr/",
  element: <PortalLayout />,
  children: [
    {
      path: "dashboard",
      element: (
        <AuthGurad>
          <Dashboard />
        </AuthGurad>
      ),
    },
    
    {
      path: "notifications",
      element: (
        <AuthGurad>
          <NotificationContainer />
        </AuthGurad>
      ),
    },
    {
      path: "roles-management",
      element: (
        <AuthGurad>
          <RolesManagement />
        </AuthGurad>
      ),
    },
    {
      path: "roles-management/modules",
      element: (
        <AuthGurad>
          <RolesModules />
        </AuthGurad>
      ),
    },
    {
      path: "roles-management/modules/:rowId",
      element: (
        <AuthGurad>
          <RolesModules />
        </AuthGurad>
      ),
    },
    {
      path: "roles-management/modules/permissions",
      element: (
        <AuthGurad>
          <ModulesPermissions />
        </AuthGurad>
      ),
    },
    {
      path: "roles-management/permissions/:rowId",
      element: (
        <AuthGurad>
          <ModulesPermissions />
        </AuthGurad>
      ),
    },
    {
      path: "pending-tasks",
      element: (
        <AuthGurad>
          <PendingTask />
        </AuthGurad>
      ),
    },
    {
      path: "change-requests",
      element: (
        <AuthGurad>
          <PendingTask />
        </AuthGurad>
      ),
    },
    {
      path: "products/product-details/:id/patient-details/:id",
      element: (
        <AuthGurad>
          <BmrAppointmentDetails />
        </AuthGurad>
      ),
    },
    {
      path: "slot-management",
      element: (
        <AuthGurad>
          <SlotManagement />
        </AuthGurad>
      ),
    },
    {
      path: "qr-generation",
      element: (
        <AuthGurad>
          <QRGeneration />
        </AuthGurad>
      ),
    },
    {
      path: "qr-generation/details",
      element: (
        <AuthGurad>
          <QRGenerationDetails />
        </AuthGurad>
      ),
    },
    {
      path: "feasibility-assessment/subjects",
      element: (
        <AuthGurad>
          <FeasibilityAssessmentSubject />
        </AuthGurad>
      ),
    },
    {
      path: "feasibility-assessment/subjects/details/:id",
      element: <BmrAppointmentDetails />,
    },
    {
      path: "feasibility-assessment/apheresis-requests/details/:id",
      element: <BmrAppointmentDetails />,
    },
    {
      path: "on-board-user",
      element: (
        <AuthGurad>
          <OnBoardUser />
        </AuthGurad>
      ),
    },
    {
      path: "on-board-user/permissions/:userId",
      element: (
        <AuthGurad>
          <ModulesPermissions />
        </AuthGurad>
      ),
    },
    {
      path: "feasibility-assessment/apheresis-requests",
      element: (
        <AuthGurad>
          <ApheresisRequests />
        </AuthGurad>
      ),
    },
    {
      path: "feasibility-assessment/bmr-slots",
      element: (
        <AuthGurad>
          <BMRSlots />
        </AuthGurad>
      ),
    },
    {
      path: "feasibility-assessment/payment-dashboard",
      element: (
        <AuthGurad>
          <PaymentStatus />
        </AuthGurad>
      ),
    },

    {
      path: "lsm",
      element: (
        <AuthGurad>
          <QRCodeGeneration />
        </AuthGurad>
      ),
    },
    {
      path: "lsm/details/:id",
      element: (
        <AuthGurad>
          <GenerateQr />
        </AuthGurad>
      ),
    },
    {
      path: "logistics-management/in-bound",
      element: (
        <AuthGurad>
          <InBound />
        </AuthGurad>
      ),
    },
    {
      path: "logistics-management/out-bound",
      element: (
        <AuthGurad>
          <OutBound />
        </AuthGurad>
      ),
    },
    {
      path: "logistics-management/out-bound/view/:id/:batchNo?",
      element: (
        <AuthGurad>
          <InBoundView />
        </AuthGurad>
      ),
    },
    {
      path: "logistics-management/in-bound/view/:id/:feasibilityId?/:batchNo?",
      element: (
        <AuthGurad>
          <InBoundView />
        </AuthGurad>
      ),
    },
    {
      path: "lsm-acceptance/lsm-received",
      element: (
        <AuthGurad>
          <LSMReceived />
        </AuthGurad>
      ),
    },
     {
      path: "lsm-acceptance/lsm-received/details/:id/:feasibilityId?",
      element: (
        <AuthGurad>
          <InBoundView />
        </AuthGurad>
      ),
    },
    {
      path: "lsm-acceptance/approval-received",
      element: (
        <AuthGurad>
          <ApprovalReceived />
        </AuthGurad>
      ),
    },
    {
      path: "lsm-acceptance/approval-received/details/:id/:feasibilityId?",
      element: (
        <AuthGurad>
          <InBoundView />
        </AuthGurad>
      ),
    },
    {
      path: "lsm-acceptance/approval-received/details/:id",
      element: (
        <AuthGurad>
          <ApprovedSubjectDetails />
        </AuthGurad>
      ),
    },
    {
      path: "inbound-form/:id",
      element: (
        <AuthGurad>
          <InboundFormContainer />
        </AuthGurad>
      ),
    },
    {
      path: "location",
      element: (
        <AuthGurad>
          <Location />
        </AuthGurad>
      ),
    },
    {
      path: "lsm-rejection-reason",
      element: (
        <AuthGurad>
          <LSMRejectionReason />
        </AuthGurad>
      ),
    },
    {
      path: "leukapheresis-condition",
      element: (
        <AuthGurad>
          <LeukapheresisCondition />
        </AuthGurad>
      ),
    },
    {
      path: "product-calculations",
      element: (
        <AuthGurad>
          <ProductCalculations />
        </AuthGurad>
      ),
    },
    {
      path: "storage-location",
      element: (
        <AuthGurad>
          <StorageLocation />
        </AuthGurad>
      ),
    }, {
      path: "lsm-acceptance-reasons",
      element: (
        <AuthGurad>
          <LSMAcceptanceReason />
        </AuthGurad>
      ),
    }, {
      path: "remanufacturing-reasons",
      element: (
        <AuthGurad>
          <RemanufacturingReasons />
        </AuthGurad>
      ),
    },
    {
      path: "delivery-partners",
      element: (
        <AuthGurad>
          <DeliveryPartners />
        </AuthGurad>
      ),
    },
    {
      path: "print-details",
      element: (
        <AuthGurad>
          <PrintDetails />
        </AuthGurad>
      ),
    },
    {
      path: "master/terminate",
      element: (
        <AuthGurad>
          <TableManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/change-request",
      element: (
        <AuthGurad>
          <TableManagement />
        </AuthGurad>
      ),
    },
     {
      path: "master/equipment",
      element: (
        <AuthGurad>
          <TableManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/logistics-partners",
      element: (
        <AuthGurad>
          <TableManagement />
        </AuthGurad>
      ),
    },
     {
      path: "master/payment",
      element: (
        <AuthGurad>
          <TableManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/clinical-feasibility",
      element: (
        <AuthGurad>
          <TableManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/financial-feasibility",
      element: (
        <AuthGurad>
          <TableManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/payment-type",
      element: (
        <AuthGurad>
          <TableManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/nationalities",
      element: (
        <AuthGurad>
          <TableManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/ethnicity",
      element: (
        <AuthGurad>
          <TableManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/disclaimers",
      element: (
        <AuthGurad>
          <Disclaimer />
        </AuthGurad>
      ),
    },
    {
      path: "master/disclaimers/add-disclaimer",
      element: (
        <AuthGurad>
          <AddNewDisclaimer/>
        </AuthGurad>
      ),
    },
    // @info this is for view 
     {
      path: "master/disclaimers/add-disclaimer/view/:id",
      element: (
        <AuthGurad>
          <AddNewDisclaimer/>
        </AuthGurad>
      ),
    },
    //@ info this is for edit 
    {
      path: "master/disclaimers/add-disclaimer/:id",
      element: (
        <AuthGurad>
          <AddNewDisclaimer/>
        </AuthGurad>
      ),
    },
    
    {
      path: "manufacturer",
      element: (
        <AuthGurad>
          <Manufacturer />
        </AuthGurad>
      ),
    },
    {
      path: "manufacturer_view/:id/:feasibility_id?",
      element: (
        <AuthGurad>
          <ManufacturerView />
        </AuthGurad>
      ),
    },
    {
          path: 'message',
          element: <AuthGurad><Message /></AuthGurad>
        },
    {
      path: "qc",
      element: (
        <AuthGurad>
          <QualityControl />
        </AuthGurad>
      ),
    },
    {
      path: "qc/:id/:feasibilityId?",
      element: (
        <AuthGurad>
          <QualityControlView1 />
        </AuthGurad>
      ),
    },
    {
      path: "qa",
      element: (
        <AuthGurad>
          <QualityApproval />
        </AuthGurad>
      ),
    },
{
      path: "qa/:id/:feasibilityId?",
      element: (
        <AuthGurad>
          <QualityControlView1 />
        </AuthGurad>
      ),
    },
    {
      path: "faq",
      element: (
        <AuthGurad>
          <Help />
        </AuthGurad>
      ),
    },
    {
      path: "faq/create",
      element: (
        <AuthGurad>
          <CreateHelp />
        </AuthGurad>
      ),
    },
    {
      path: "faq/detail/:id",
      element: (
        <AuthGurad>
          <CreateHelp />
        </AuthGurad>
      ),
    },
    {
      path: "faq/view",
      element: (
        <AuthGurad>
          <DetailHelp />
        </AuthGurad>
      ),
    },
    {
      path: "faq/listing",
      element: (
        <AuthGurad>
          <ViewProcessingAccordian />
        </AuthGurad>
      ),
    },
    {
      path: "form-management",
      element: (
        <AuthGurad>
          <TemplateManagement />
        </AuthGurad>
      ),
    },
    {
      path: 'form-management/:id',
      element: <FormBuilder />,
      children: FbRoutes
    },
     {
      path: "assigned-permission",
      element: (
        <AuthGurad>
          <FormAssigned />
        </AuthGurad>
      ),
    },
     {
      path: "formbuilder-master-data",
      element: (
        <AuthGurad>
          <FormBuilderMasterData/>
        </AuthGurad>
      ),
    },
    {
      path: "assigned-permission/assign-section-permission/:id/:assignedId",
      element: (
        <AuthGurad>
          <AssignSectionPermission />
        </AuthGurad>
      ),
    },{
      path: "assigned-permission/view/:id/:assignedId/assign-section-permission",
      element: (
        <AuthGurad>
          <AssignSectionPermission />
        </AuthGurad>
      ),
    },

    {
      path: 'lsm-approval-requests',
      element: <LSMApprovalRequests />,
      children: FbRoutes
    },
    {
      path: "download-center",
      element: (
        <AuthGurad>
          <DownloadCenter />
        </AuthGurad>
      ),
    },
    {
      path: "download-center/patient-details/:qrId/:feasibiltyID",
      element: (
        <AuthGurad>
          <ViewDetails />
        </AuthGurad>
      ),
    },
     {
      path: "notification-center",
      element: (
        <AuthGurad>
          <EmailTemplate />
        </AuthGurad>
      ),
    },
     {
      path: "notification-center/create-notification-center",
      element: (
        <AuthGurad>
          <CreateEmailTemplate />
        </AuthGurad>
      ),
    },
    //@todo need this later
     {
      path: "notification-center/create-notification-center/:id",
      element: (
        <AuthGurad>
          <CreateEmailTemplate />
        </AuthGurad>
      ),
    },
    {
      path: "master/city",
      element: (
        <AuthGurad>
          <CityManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/logs",
      element: (
        <AuthGurad>
          <LogsManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/logs/view/:id",
      element: (
        <AuthGurad>
          <ViewLog />
        </AuthGurad>
      ),
    },
    {
      path: "master/state",
      element: (
        <AuthGurad>
          <StateManagement />
        </AuthGurad>
      ),
    },
    {
      path: "master/country",
      element: (
        <AuthGurad>
          <CountryManagement />
        </AuthGurad>
      ),
    },
  ],
};
export default BmrRoutes;
